const version = '1.0.0';
const snackbar_config = {
  snackbar_duration: 2000,
  snackbar_error_duration: 10000,
};
const bypass_auth_token_resources = ['https://diasnespressostorage.blob.core.windows.net'];

export const GLOBAL_CONFIG = {
  snackbar_config,
  bypass_auth_token_resources,
  version,
};
